import { FullProduct } from "ts/api/product";
import { apiV2 } from "api/firebase";
import { IIncrementCustomProductOptionConfigOverridePurchasedQuantityPayload } from "@evennt-tech/api-v2-external";

const incrementProductsPurchasedQuantity = async (
  showId: string,
  products: Pick<
    FullProduct,
    "cartQuantity" | "quantity" | "cpoConfigId" | "id"
  >[]
) => {
  const quantities: IIncrementCustomProductOptionConfigOverridePurchasedQuantityPayload[] = [];

  products.forEach((product) => {
    let quantity = 0;
    if ("cartQuantity" in product && product.cartQuantity) {
      quantity = product.cartQuantity;
    } else {
      quantity = product.quantity;
    }
    if (product.cpoConfigId) {
      quantities.push({
        incrementBy: Math.ceil(quantity),
        cpoConfigId: product.cpoConfigId,
      });
    }
  });

  if (quantities.length) {
    await apiV2.customProductOption.override.incrementQuantities({
      showId,
      values: quantities,
    });
  }
};

export default incrementProductsPurchasedQuantity;
